<template>
  <div id="outbox">
    <el-tabs type="card">
        
      <el-tab-pane label="收件箱">
    <div class="filter clearfix">
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="4">
          <el-radio-group v-model="type" @change="changeRadio">
            <el-radio-button label="1">消息</el-radio-button>
            <el-radio-button label="2">公告</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        @row-click="clickrow"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" min-width="5%"></el-table-column>
        <el-table-column label="标题" prop="title" min-width="8%" align="center">
           <template slot-scope="scope">
              <a>{{scope.row.title}}</a>
          </template>
        </el-table-column>
        <el-table-column label="消息内容" prop="content" min-width="20%" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="状态" min-width="4%" align="center" v-if="type=='1'">
          <template slot-scope='scope'>
            <span class="text-success" v-if="scope.row.readFlag== true">已读</span>
            <span class="text-warning" v-else>未读</span>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" prop="push_time" min-width="8%" align="center" :formatter="dateForma"></el-table-column>
      </el-table>
      <div class="wrap_footer clearfix">
        <div class="left">
          <!--<el-button @click="exportExcell()">导出表单</el-button>-->
        </div>
        <div class="right">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="msgForm.pageIndex"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="msgForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="消息详情"
      v-if="newshow"
      :visible.sync="newshow"
      width="50%"
      :before-close="handleClose">
       <div class="title">{{news.title}}</div>
        <div class="time" >{{news.push_time}}</div> 
        <div class="content" v-html="news.content"></div>
    </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
  export default {
    name: "outbox",
    props:[
      'tabindex'
    ],
    created(){
      let me = this;
      me.$watch('tabindex',function (val,oldval) {
        if(val == 0){
          me.initMsg();
        }
      });
    },
    data() {
      return {
        news:"",
        newshow:false,
        index: 'message',
        msgForm:{
            readFlag:null,
            title:null,
            content:null,
            pushAll:false,
            pushObjType:3,
             pageIndex:1,
             pageSize:5,  
        },
        type:1,
        allLoaded:false,
        totalPage:0,
        msgIds:[],
        readFlag:true,
        tableData:[]
      }
    },
    mounted() {
      let me = this;
      me.initMsg();
    },
    methods: {
       dateForma:function(row,column){
        var date = parseInt(row[column.property]);
        if(date == undefined||!date){return ''};
        return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },
      handleClose(){
           this.msgForm.pageIndex=1;
           this.msgForm.pageSize=5;
          
          this.newshow=false;
      },
       async clickrow(row){
          row.content=row.content.replace(/\n/gi, '<br />');
          this.news=row;
          this.msgIds.push(row.receivingId);
          let me=this;
         if(me.type=='1'){
            if(!row.readFlag){
               let res = await me.$userService.updateMsgStatus(this.msgIds,this.readFlag);
                if(res&&res['success']){
                    me.initMsg();
            }
            }
         }
          this.newshow=true;
      },
      //处理表格勾选行
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      async initMsg(){
        let me = this;
        me.tableData=[];
        let param=me.msgForm;
        let res = await me.$userService.queryMsgReceiving(param);
        if(res&&res['success']){
          me.msgForm.pageIndex=res.content.page;
          me.totalPage=res.content.total;
          me.tableData=res['content']['records'];
          if(me.tableData.length<res.content.total){
             me.allLoaded = false; 
            
          
            }
        }
      },
      //处理每页显示数量
      handleSizeChange(val) {
        this.msgForm.pageSize = val;
        this.initMsg();
      },
      //处理翻页
      handleCurrentChange(val) {
        this.msgForm.pageIndex = val;
        this.initMsg();
      },
      //处理筛选
      handleQuery: async function() {
        let me = this;
       me.msgForm.pageIndex=1
       me.msgForm.pageSize=5
        this.initMsg();
      },
      changeRadio(e){
        let me = this;
        switch (me.type) {
          case '1':
            me.readFlag = true;
            me.msgForm.pushAll=false;
            break;
          case '2':
            me.readFlag = true;
             me.msgForm.pushAll=true;
            break;
          
        }
        me.msgForm.pageIndex = 1;
        me.initMsg();
      },
      
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/less/global.less';
  @import '../../../assets/css/icon.css';
  @import '../../../assets/css/app.css';
  #outbox{
      .title{
        font-size: 18px;
        color:#333;
        text-align: center;
      }
      .time{
        color: #999;margin:10px 0;text-align: center;
      }
      .content{
        font-size: 16px;
      }
      .el-tooltip__popper{font-size: 14px; max-width:400px; } 
  }
</style>



// WEBPACK FOOTER //
// src/components/message/child/outbox.vue